import { render, staticRenderFns } from "./invoiceDetailModal.vue?vue&type=template&id=f4c4d754&scoped=true"
import script from "./invoiceDetailModal.vue?vue&type=script&lang=js"
export * from "./invoiceDetailModal.vue?vue&type=script&lang=js"
import style0 from "./invoiceDetailModal.vue?vue&type=style&index=0&id=f4c4d754&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4c4d754",
  null
  
)

export default component.exports